import { useSmartProp } from '@smartfire/js-block-engine'
import { PanelBody, PanelRow, TextControl } from '@wordpress/components'

const Inspector = () => {
    const [linkDonation, setLinkDonation] = useSmartProp('linkDonation')
    const [labelDonation, setLabelDonation] = useSmartProp('labelDonation')

    return (
        <PanelBody title={'Don'}>
            <PanelRow>
                <TextControl
                    label="Lien vers la page"
                    value={linkDonation}
                    onChange={setLinkDonation}
                />
            </PanelRow>
            <PanelRow>
                <TextControl label="Libellé" value={labelDonation} onChange={setLabelDonation} />
            </PanelRow>
        </PanelBody>
    )
}

export default Inspector
